import { render, staticRenderFns } from "./CommunitySubMenu.vue?vue&type=template&id=1e9e547a&"
import script from "./CommunitySubMenu.vue?vue&type=script&lang=ts&"
export * from "./CommunitySubMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CommunitySubMenu.vue?vue&type=style&index=0&id=1e9e547a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports